export const SPOTLIGHT_SHORTCUT = "mod + k";
export const ACTION_LIMIT_PER_ENTITY = 4;
const NUMBER_OF_GROUPS = 3;

export const ACTIONS_LIMIT = ACTION_LIMIT_PER_ENTITY * NUMBER_OF_GROUPS;
